package com.patronat.top.client.data.venues

import com.patronat.top.core.network.NetworkResult
import com.patronat.top.core.network.safeApiCall
import com.patronat.top.dto.SavedVenueIdsResponse
import com.patronat.top.dto.VenueFilterRequest
import com.patronat.top.dto.VenueListResponse
import com.patronat.top.dto.VenueResponse
import com.patronat.top.dto.VenueServiceSuggestionsResponse
import io.ktor.client.HttpClient
import io.ktor.client.request.delete
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.client.request.post
import io.ktor.client.request.put
import io.ktor.client.request.setBody

class ClientVenuesRemoteDataSource(
    private val httpClient: HttpClient
) {
    suspend fun filterVenues(request: VenueFilterRequest): NetworkResult<VenueListResponse> {
        return safeApiCall {
            httpClient.post("venues/filter") {
                setBody(request)
            }
        }
    }

    suspend fun getVenueById(venueId: String): NetworkResult<VenueResponse> {
        return safeApiCall {
            httpClient.get("venues/$venueId")
        }
    }

    suspend fun suggestServices(query: String): NetworkResult<VenueServiceSuggestionsResponse> {
        return safeApiCall {
            httpClient.get("venues/services/suggest") {
                parameter("query", query)
                parameter("limit", 20)
            }
        }
    }

    suspend fun getSavedVenueIds(): NetworkResult<SavedVenueIdsResponse> {
        return safeApiCall {
            httpClient.get("venues/saved/ids")
        }
    }

    suspend fun getSavedVenues(
        page: Int,
        pageSize: Int,
        query: String?
    ): NetworkResult<VenueListResponse> {
        return safeApiCall {
            httpClient.get("venues/saved") {
                parameter("page", page)
                parameter("pageSize", pageSize)
                if (!query.isNullOrBlank()) {
                    parameter("query", query)
                }
            }
        }
    }

    suspend fun saveVenue(venueId: String): NetworkResult<Unit> {
        return safeApiCall {
            httpClient.put("venues/$venueId/saved")
        }
    }

    suspend fun unsaveVenue(venueId: String): NetworkResult<Unit> {
        return safeApiCall {
            httpClient.delete("venues/$venueId/saved")
        }
    }
}
